//Search page
export const SEARCH_TYPING = "SEARCH_TYPING"
export const SEARCH_ERROR = "SEARCH_ERROR"
export const SEARCH_ADD_CONTENT = "SEARCH_ADD_CONTENT"
export const SEARCH_SUCCESS = "SEARCH_SUCCESS"
export const SEARCH_RESULTS_CLEAR = "SEARCH_RESULTS_CLEAR"
export const SEARCH_UPDATE_DOCUMENT_PRIORITY = "SEARCH_CONCEPT_UPDATE_DOCUMENT_PRIORITY"
export const SEARCH_UPDATE_DOCUMENT_DATE = "SEARCH_CONCEPT_UPDATE_DOCUMENT_DATE"
export const SEARCH_CLEAR_CONCEPT_TARGET_TERMS = "SEARCH_CLEAR_CONCEPT_TARGET_TERMS"
export const SEARCH_ADD_CONCEPT_TARGET_TERMS = "SEARCH_ADD_CONCEPT_TARGET_TERMS"
export const SEARCH_SET_SOURCE_FILTER = "SEARCH_SET_SOURCE_FILTER"
export const SEARCH_LOAD_STORAGE = "SEARCH_LOAD_STORAGE"
export const SEARCH_DELETE_STORAGE = "SEARCH_DELETE_STORAGE"
export const SEARCH_LOAD_ALL_STORAGE_SEARCHS = "SEARCH_LOAD_ALL_STORAGE_SEARCHS"
export const SELECTED_SEARCH = "SELECTED_SEARCH"
export const UPDATE_SEARCH_METADATA = "UPDATE_SEARCH_METADATA"

//Login
export const LOGIN_REQUEST = "USERS_LOGIN_REQUEST"
export const LOGIN_SUCCESS = "USERS_LOGIN_SUCCESS"
export const LOGIN_FAILURE = "USERS_LOGIN_FAILURE"
export const LOGOUT = "USERS_LOGOUT"
export const LOGIN_AZURE = "LOGIN_AZURE"
export const GET_USERS_LIST = "GET_USERS_LIST"
export const LOGOUT_CLEAR_STORE = "LOGOUT_CLEAR_STORE"
export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const LOGOUT_USER_FAILURE = "LOGOUT_USER_FAILURE"

export const GETALL_REQUEST = "USERS_GETALL_REQUEST"
export const GETALL_SUCCESS = "USERS_GETALL_SUCCESS"
export const GETALL_FAILURE = "USERS_GETALL_FAILURE"
//multibaseUI => once we select new base will need to update token
export const UPDATE_NEW_TOKEN = "UPDATE_NEW_TOKEN"

//AzureAD login
export const AZUREAD_LOGIN_URL_REQUEST = "AZUREAD_LOGIN_URL_REQUEST"
export const AZUREAD_LOGIN_URL_REQUEST_SUCCESS = "AZUREAD_LOGIN_URL_REQUEST_SUCCESS"
export const AZUREAD_LOGIN_URL_REQUEST_FAILURE = "AZUREAD_LOGIN_URL_REQUEST_FAILURE"
export const AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR = "AZUREAD_LOGIN_URL_REQUEST_FAILURE_CLEAR"

export const AZUREAD_LOGIN_REQUEST = "AZUREAD_LOGIN_REQUEST"
export const AZUREAD_LOGIN_SUCCESS = "AZUREAD_LOGIN_SUCCESS"
export const AZUREAD_LOGIN_FAILURE = "AZUREAD_LOGIN_FAILURE"
export const AZUREAD_LOGIN_FAILURE_CLEAR = "AZUREAD_LOGIN_FAILURE_CLEAR"

//Alerts
export const SHOW_ALERT = "SHOW_ALERT"
export const HIDE_ALERT = "HIDE_ALERT"
export const HIDE_MODAL_ALERT = "HIDE_ALERT"

//Build concepts
export const TOPICBUILDER_SEARCHING = "TOPICBUILDER_SEARCHING"
export const TOPICBUILDER_SAVE_CURRENT_SEARCH = "TOPICBUILDER_SAVE_CURRENT_SEARCH"
export const TOPICBUILDER_SEARCH_ERROR = "TOPICBUILDER_SEARCH_ERROR"
export const TOPICBUILDER_SEARCH_SUCCESS = "TOPICBUILDER_SEARCH_SUCCESS"
export const TERM_SELECT_AS_TARGET = "TERM_SELECT_AS_TARGET"
export const TERM_SELECT_AS_IGNORED_RELATED = "TERM_SELECT_AS_IGNORED_RELATED"
export const TERM_SELECT_AS_INCLUDE_SPECIFIC = "TERM_SELECT_AS_INCLUDE_SPECIFIC"
export const TERM_SELECT_AS_IGNORE_SPECIFIC = "TERM_SELECT_AS_IGNORE_SPECIFIC"
export const SET_SEARCH_TERMS = "SET_SEARCH_TERMS"
export const SET_REFRESH_TERM_LIST = "SET_REFRESH_TERM_LIST"
export const SET_TARGET_TERMS = "SET_TARGET_TERMS"
export const BUILD_CONCEPT_UNSAVED = "BUILD_CONCEPT_UNSAVED"
export const BULD_CONCEPT_LOADING_END = "BULD_CONCEPT_LOADING_END"
export const BUILD_CONCEPT_CURRENT_FILTER_CHANGE = "BUILD_CONCEPT_CURRENT_FILTER_CHANGE"
export const SAVED_BUILD_CONCEPTS_SEARCHING = "SAVED_BUILD_CONCEPTS_SEARCHING"
export const SAVED_BUILD_CONCEPTS_SEARCHING_ERROR = "SAVED_BUILD_CONCEPTS_SEARCHING_ERROR"
export const SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS = "SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS"
export const SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS = "SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS"
export const RANGE_FILTER_SAVING_START = "RANGE_FILTER_SAVING_START"
export const RANGE_FILTER_SAVING_END = "RANGE_FILTER_SAVING_END"
export const BUILD_CONCEPT_SAVE_CURRENT_UUID = "BUILD_CONCEPT_SAVE_CURRENT_UUID"
export const BUILD_CONCEPT_FIND_DOCUMENTS = "BUILD_CONCEPT_FIND_DOCUMENTS"
export const BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS = "BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS"
export const BUILD_CONCEPT_CLEAR_TERMS = "BUILD_CONCEPT_CLEAR_TERMS"
export const BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY = "BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY"
export const BUILD_CONCEPT_UPDATE_DOCUMENT_DATE = "BUILD_CONCEPT_UPDATE_DOCUMENT_DATE"
export const BUILD_CONCEPT_SET_SOURCE_FILTER = "BUILD_CONCEPT_SET_SOURCE_FILTER"
export const BUILD_CONCEPT_FORCE_FILTER_REFRESH = "BUILD_CONCEPT_FORCE_FILTER_REFRESH"
export const BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS = "BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS"
export const BUILD_CONCEPT_SEARCHING_DOCS = "BUILD_CONCEPT_SEARCHING_DOCS"
export const UPDATE_LAST_CONCEPTS_CALL = "UPDATE_LAST_CONCEPTS_CALL"
export const BUILD_CONCEPT_IS_LOADING_DOCS = "BUILD_CONCEPT_IS_LOADING_DOCS"
export const BUILD_CONCEPT_CLEAR_BUTTON = "BUILD_CONCEPT_CLEAR_BUTTON"
export const BUILD_CONCEPT_CLEAR_ALL = "BUILD_CONCEPT_CLEAR_ALL"
export const SELECTED_BUILD_CONCEPT = "SELECTED_BUILD_CONCEPT"
export const UPDATE_BUILD_CONCEPT_METADATA = "UPDATE_BUILD_CONCEPT_METADATA"

//Docuemnts
export const DOCUMENT_SET_PRIORITY = "DOCUMENT_SET_PRIORITY"
export const DOCUMENT_DOWNLOAD = "DOCUMENT_DOWNLOAD"
export const BUILD_CONCEPT_FORCE_CLOUD_REFRESH = "BUILD_CONCEPT_FORCE_CLOUD_REFRESH"
export const UPDATE_FILE_LIST_COMMENT = "UPDATE_FILE_LIST_COMMENT"

//Timeline
export const TIMELINE_SEARCH_TYPING = "TIMELINE_SEARCH_TYPING"
export const TIMELINE_SEARCH_SUCCESS = "TIMELINE_SEARCH_SUCCESS"
export const TIMELINE_SEARCH_ERROR = "TIMELINE_SEARCH_ERROR"
export const TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY = "TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY"
export const TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS = "TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS"
export const TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS = "TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS"
export const TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE = "TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE"
export const TIMELINE_SET_SOURCE_FILTER = "TIMELINE_SET_SOURCE_FILTER"
export const TIMELINE_RESULTS_CLEAR = "TIMELINE_RESULTS_CLEAR"
export const UPDATE_TIMELINE_METADATA = "UPDATE_TIMELINE_METADATA"
export const GET_GRAPH_DATA_REQUEST = "GET_GRAPH_DATA_REQUEST"
export const GET_GRAPH_DATA_REQUEST_SUCCESS = "GET_GRAPH_DATA_REQUEST_SUCCESS"
export const GET_GRAPH_DATA_REQUEST_FAILED = "GET_GRAPH_DATA_REQUEST_FAILED"
export const GET_GRAPH_DATA_REQUEST_CLEAR = "GET_GRAPH_DATA_REQUEST_CLEAR"

//View Documents
export const VIEWDOCUMENTS_SEARCH_ERROR = "VIEWDOCUMENTS_SEARCH_ERROR"
export const VIEWDOCUMENTS_FIND_DOCUMENTS = "VIEWDOCUMENTS_FIND_DOCUMENTS"
export const VIEWDOCUMENTS_SEARCHING = "VIEWDOCUMENTS_SEARCHING"
export const VIEWDOCUMENTS_SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS = "VIEWDOCUMENTS_SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS"
export const VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS = "VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS"
export const VIEWDOCUMENTS_SET_SOURCE_FILTER = "VIEWDOCUMENTS_SET_SOURCE_FILTER"
export const VIEWDOCUMENTS_LOAD_CURRENT_TERMS = "VIEWDOCUMENTS_LOAD_CURRENT_TERMS"
export const VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY = "VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY"
export const UPDATE_VIEWDOCUMENTS_METADATA = "UPDATE_VIEWDOCUMENTS_METADATA"

export const GET_ALL_DOCUMENTS_REQUEST = "GET_ALL_DOCUMENTS_REQUEST"
export const GET_ALL_DOCUMENTS_REQUEST_SUCCESS = "GET_ALL_DOCUMENTS_REQUEST_SUCCESS"
export const GET_ALL_DOCUMENTS_REQUEST_FAILED = "GET_ALL_DOCUMENTS_REQUEST_FAILED"
export const GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR = "GET_ALL_DOCUMENTS_REQUEST_FAILED_CLEAR"
export const DOCUMENTS_SET_PRIORITY_REQUEST = "DOCUMENTS_SET_PRIORITY_REQUEST"
export const GET_DOCUMENTS_REQUEST = "GET_DOCUMENTS_REQUEST"
export const GET_DOCUMENTS_REQUEST_SUCCESS = "GET_DOCUMENTS_REQUEST_SUCCESS"
export const GET_DOCUMENTS_REQUEST_FAILED = "GET_DOCUMENTS_REQUEST_FAILED"
export const GET_DOCUMENTS_REQUEST_FAILED_CLEAR = "GET_DOCUMENTS_REQUEST_FAILED_CLEAR"

export const GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST = "GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST"
export const GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS = "GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_SUCCESS"
export const GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED = "GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED"
export const GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR = "GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST_FAILED_CLEAR"
export const SET_EXPAND_GRAPH = "SET_EXPAND_GRAPH"

export const UPDATE_METADATA = "UPDATE_METADATA"

//Current Searches
export const CURRENT_SEARCH_ITEMS = "CURRENT_SEARCH_ITEMS"
export const CLEAR_TIMELINE_SEARCH_ITEMS = "CLEAR_TIMELINE_SEARCH_ITEMS"

//HighlightFilter
export const SEARCH_HIGHLIGHT_FILTER = "SEARCH_HIGHLIGHT_FILTER"
export const BUILD_HIGHLIGHT_FILTER = "BUILD_HIGHLIGHT_FILTER"
export const TIMELINE_HIGHLIGHT_FILTER = "TIMELINE_HIGHLIGHT_FILTER"
export const VIEWDOCUMENTS_HIGHLIGHT_FILTER = "VIEWDOCUMENTS_HIGHLIGHT_FILTER"
export const SEARCH_CURRENT_TAGS = "SEARCH_CURRENT_TAGS"
export const BUILD_CURRENT_TAGS = "BUILD_CURRENT_TAGS"
export const TIMELINE_CURRENT_TAGS = "TIMELINE_CURRENT_TAGS"
export const VIEWDOCUMENTS_CURRENT_TAGS = "VIEWDOCUMENTS_CURRENT_TAGS"
export const SEARCH_CURRENT_TAGS_EXCLUDE = "SEARCH_CURRENT_TAGS_EXCLUDE"
export const BUILD_CURRENT_TAGS_EXCLUDE = "BUILD_CURRENT_TAGS_EXCLUDE"
export const TIMELINE_CURRENT_TAGS_EXCLUDE = "TIMELINE_CURRENT_TAGS_EXCLUDE"
export const VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE = "VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE"
export const CONCEPT_BASED_ON_ID = "CONCEPT_BASED_ON_ID"
export const CONCEPT_BASED_ON_ID_SUCCESS = "CONCEPT_BASED_ON_ID_SUCCESS"
export const CONCEPT_BASED_ON_ID_FAILED = "CONCEPT_BASED_ON_ID_FAILED"
export const RESET_HIGHLIGHT_FILTER = "RESET_HIGHLIGHT_FILTER"
export const SAVE_HIGHLIGHT_STATE = "SAVE_HIGHLIGHT_STATE"
export const UPDATE_ANNOTATION = "UPDATE_ANNOTATION"

//Sources
export const GET_DOCS_SOURCES = "GET_DOCS_SOURCES"

//Downloads
export const START_DOWNLOAD = "START_DOWNLOAD"
export const END_DOWNLOAD = "END_DOWNLOAD"
export const DOWNLOAD_PROGRESS = "DOWNLOAD_PROGRESS"
export const START_BULK_DOWNLOAD = "START_BULK_DOWNLOAD"
export const END_BULK_DOWNLOAD = "END_BULK_DOWNLOAD"
export const DOWNLOAD_BULK_PROGRESS = "DOWNLOAD_BULK_PROGRESS"
export const SET_SELECTED_DOCUMENT_IDS = "SET_SELECTED_DOCUMENT_IDS"
export const RESET_SELECTED_DOCUMENT_IDS = "RESET_SELECTED_DOCUMENT_IDS"

//Delete file
export const START_DELETE = "START_DELETE"
export const END_DELETE = "END_DELETE"
export const DELETE_PROGRESS = "DELETE_PROGRESS"
export const START_BULK_DELETE = "START_BULK_DELETE"
export const END_BULK_DELETE = "END_BULK_DELETE"
export const DELETE_BULK_PROGRESS = "DELETE_BULK_PROGRESS"

//Tags
export const GET_CUSTOM_TAGS = "GET_CUSTOM_TAGS"
export const ADD_CUSTOM_TAGS = "ADD_CUSTOM_TAGS"
export const UPDATE_CUSTOM_TAGS = "UPDATE_CUSTOM_TAGS"

//Documents
export const DOCUMENT_RELOAD_COMMENTS_REQUEST = "DOCUMENT_RELOAD_COMMENTS_REQUEST"
export const DOCUMENT_COUNT_COMMENTS_SUCCESS = "DOCUMENT_COUNT_COMMENTS_SUCCESS"

//SAGAS
export const REQUEST_SOURCES = "REQUEST_SOURCES"
export const REQUEST_CUSTOM_TAGS = "REQUEST_CUSTOM_TAGS"
export const REQUEST_SAVED_BUILD_CONCEPTS = "REQUEST_SAVED_BUILD_CONCEPTS"
export const NEW_HIDE_ALERT = "NEW_HIDE_ALERT"
export const REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS = "REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS"
export const REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER = "REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER"
export const REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER =
	"REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER"

export const REQUEST_LOAD_CONCEPT_API = "REQUEST_LOAD_CONCEPT_API"
export const REQUEST_SEARCH_TYPING = "REQUEST_SEARCH_TYPING"
export const REQUEST_LOAD_DOCUMENTS_OF_CONCEPT = "REQUEST_LOAD_DOCUMENTS_OF_CONCEPT"
export const REQUEST_SEARCH_FOR_TOPIC_API = "REQUEST_SEARCH_FOR_TOPIC_API"
export const REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT = "REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT"
export const REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS = "REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS"
export const REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_SUCCESS = "REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_SUCCESS"
export const REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED = "REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED"
export const REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR =
	"REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS_FAILED_CLEAR"

export const REQUEST_SAVE_CONCEPT = "REQUEST_SAVE_CONCEPT"
export const REQUEST_SAVE_CONCEPT_SUCCESS = "REQUEST_SAVE_CONCEPT_SUCCESS"
export const REQUEST_SAVE_CONCEPT_FAILED = "REQUEST_SAVE_CONCEPT_FAILED"
export const REQUEST_SAVE_CONCEPT_CLEAR = "REQUEST_SAVE_CONCEPT_CLEAR"

export const BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS_NEW_API = "BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS_NEW_API"
export const REMOVE_CONCEPT = "REMOVE_CONCEPT"
export const GET_SAVED_BUILD_CONCEPT_ON_API = "GET_SAVED_BUILD_CONCEPT_ON_API"
export const SAVED_SEARCH_LOAD_ALL = "SAVED_SEARCH_LOAD_ALL"
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER"
export const SET_PRIORITY_ACTION = "SET_PRIORITY_ACTION"
export const SET_PRIORITY_CUSTOM_TAG = "SET_PRIORITY_CUSTOM_TAG"
export const DELETE_TAG = "DELETE_TAG"
export const SET_DOCUMENT_DATE = "SET_DOCUMENT_DATE"
export const DOWNLOAD_DOCUMENT_FAQ = "DOWNLOAD_DOCUMENT_FAQ"
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT"
export const DOWNLOAD_DOCUMENTS_OF_CONCEPT = "DOWNLOAD_DOCUMENTS_OF_CONCEPT"
export const ADD_COMMENT = "ADD_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const DOWNLOAD_ZIP = "DOWNLOAD_ZIP"
export const DELETE_SEARCH_LOAD = "DELETE_SEARCH_LOAD"
export const DELETE_SEARCH_SUCCESS = "DELETE_SEARCH_SUCCESS"
export const DELETE_SEARCH_FAILED = "DELETE_SEARCH_FAILED"
export const DELETE_SEARCH_RESET = "DELETE_SEARCH_RESET"
export const SAVE_NEW_SEARCH = "SAVE_NEW_SEARCH"
export const SAVE_NEW_SEARCH_SUCCESS = "SAVE_NEW_SEARCH_SUCCESS"
export const SAVE_NEW_SEARCH_FAILED = "SAVE_NEW_SEARCH_FAILED"
export const SAVE_NEW_SEARCH_FAILED_CLEAR = "SAVE_NEW_SEARCH_FAILED_CLEAR"
export const LOAD_DOCUMENTS_OF_CONCEPT = "LOAD_DOCUMENTS_OF_CONCEPT"
export const LOAD_CONCEPT_FROM_API = "LOAD_CONCEPT_FROM_API"
export const GET_TARGET_TERMS_OF_CATEGORY = "GET_TARGET_TERMS_OF_CATEGORY"
export const LOAD_SEARCH_FROM_API = "LOAD_SEARCH_FROM_API"
export const REQUEST_LOGIN_AZURE = "REQUEST_LOGIN_AZURE"
export const GET_CONCURRENT_USERS = "GET_CONCURRENT_USERS"
export const ERROR_USER = "ERROR_USER"
export const REQUEST_TIMELINE_SEARCH_TYPING = "REQUEST_TIMELINE_SEARCH_TYPING"
export const SEARCH_DOCS_DATA_SUCCESS = "SEARCH_DOCS_DATA_SUCCESS"
export const TIMELINE_SEARCH_DOCS_DATA_SUCCESS = "TIMELINE_SEARCH_DOCS_DATA_SUCCESS"

export const GET_TIMELINE_SEARCH_REQUEST = "GET_TIMELINE_SEARCH_REQUEST"
export const GET_TIMELINE_SEARCH_REQUEST_FAILED = "GET_TIMELINE_SEARCH_REQUEST_FAILED"
export const GET_TIMELINE_SEARCH_REQUEST_CLEAR = "GET_TIMELINE_SEARCH_REQUEST_CLEAR"

//JOB
export const CHECK_JOB_STATUS = "CHECK_JOB_STATUS"
export const JOB_STATUS_SUCCESS = "JOB_STATUS_SUCCESS"
export const JOB_STATUS_PENDING = "JOB_STATUS_PENDING"

//Token not valid
export const TOKEN_INVALID = "TOKEN_INVALID"

//Multi AI base
export const SET_AI_BASE = "SET_AI_BASE"
export const MULTIBASE_AI_LIST = "MULTIBASE_AI_LIST"
export const CLEAR_STORE = "CLEAR_STORE"

export const SET_AI_BASE_REQUEST = "SET_AI_BASE_REQUEST"
export const SET_AI_BASE_REQUEST_SUCCESS = "SET_AI_BASE_REQUEST_SUCCESS"
export const SET_AI_BASE_REQUEST_FAILED = "SET_AI_BASE_REQUEST_FAILED"
export const SET_AI_BASE_REQUEST_FAILED_CLEAR = "SET_AI_BASE_REQUEST_FAILED_CLEAR"
export const CLEAR_MULTIBASE = "CLEAR_MULTIBASE"

//bifrost
export const CREATE_CASE_REQUEST = "CREATE_CASE_REQUEST"
export const CREATE_CASE_REQUEST_SUCCESS = "CREATE_CASE_REQUEST_SUCCESS"
export const CREATE_CASE_REQUEST_FAILED = "CREATE_CASE_REQUEST_FAILED"
export const CREATE_CASE_REQUEST_FAILED_CLEAR = "CREATE_CASE_REQUEST_FAILED_CLEAR"

export const GET_CASE_LIST_REQUEST = "GET_CASE_LIST_REQUEST"
export const GET_CASE_LIST_REQUEST_SUCCESS = "GET_CASE_LIST_REQUEST_SUCCESS"
export const GET_CASE_LIST_REQUEST_FAILED = "GET_CASE_LIST_REQUEST_FAILED"
export const GET_CASE_LIST_REQUEST_FAILED_CLEAR = "GET_CASE_LIST_REQUEST_FAILED_CLEAR"

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST"
export const UPLOAD_FILE_REQUEST_SUCCESS = "UPLOAD_FILE_REQUEST_SUCCESS"
export const UPLOAD_FILE_REQUEST_FAILED = "UPLOAD_FILE_REQUEST_FAILED"
export const UPLOAD_FILE_REQUEST_CLEAR = "UPLOAD_FILE_REQUEST_CLEAR"
export const UPLOAD_FILE_REQUEST_CLEAR_ALL = "UPLOAD_FILE_REQUEST_CLEAR_ALL"

export const EXTRACT_FILE_REQUEST = "EXTRACT_FILE_REQUEST"
export const EXTRACT_FILE_REQUEST_SUCCESS = "EXTRACT_FILE_REQUEST_SUCCESS"
export const EXTRACT_FILE_REQUEST_FAILED = "EXTRACT_FILE_REQUEST_FAILED"
export const EXTRACT_FILE_REQUEST_CLEAR = "EXTRACT_FILE_REQUEST_CLEAR"
export const EXTRACT_FILE_REQUEST_CLEAR_ALL = "EXTRACT_FILE_REQUEST_CLEAR_ALL"

export const KB_MAKING_TRIGGER_REQUEST = "KB_MAKING_TRIGGER_REQUEST"
export const KB_MAKING_TRIGGER_REQUEST_SUCCESS = "KB_MAKING_TRIGGER_REQUEST_SUCCESS"
export const KB_MAKING_TRIGGER_REQUEST_FAILED = "KB_MAKING_TRIGGER_REQUEST_FAILED"
export const KB_MAKING_TRIGGER_REQUEST_CLEAR = "KB_MAKING_TRIGGER_REQUEST_CLEAR"
export const KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL = "KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL"

export const PII_EXTRACT_TRIGGER_REQUEST = "PII_EXTRACT_TRIGGER_REQUEST"
export const PII_EXTRACT_TRIGGER_REQUEST_SUCCESS = "PII_EXTRACT_TRIGGER_REQUEST_SUCCESS"
export const PII_EXTRACT_TRIGGER_REQUEST_FAILED = "PII_EXTRACT_TRIGGER_REQUEST_FAILED"
export const PII_EXTRACT_TRIGGER_REQUEST_CLEAR = "PII_EXTRACT_TRIGGER_REQUEST_CLEAR"
export const PII_EXTRACT_TRIGGER_REQUEST_CLEAR_ALL = "PII_EXTRACT_TRIGGER_REQUEST_CLEAR_ALL"

export const REVERT_PII_EXTRACT_REQUEST = "REVERT_PII_EXTRACT_REQUEST"
export const REVERT_PII_EXTRACT_REQUEST_SUCCESS = "REVERT_PII_EXTRACT_REQUEST_SUCCESS"
export const REVERT_PII_EXTRACT_REQUEST_FAILED = "REVERT_PII_EXTRACT_REQUEST_FAILED"
export const REVERT_PII_EXTRACT_REQUEST_CLEAR = "REVERT_PII_EXTRACT_REQUEST_CLEAR"
export const REVERT_PII_EXTRACT_REQUEST_CLEAR_ALL = "REVERT_PII_EXTRACT_REQUEST_CLEAR_ALL"

export const REVERT_TEXT_EXTRACT_REQUEST = "REVERT_TEXT_EXTRACT_REQUEST"
export const REVERT_TEXT_EXTRACT_REQUEST_SUCCESS = "REVERT_TEXT_EXTRACT_REQUEST_SUCCESS"
export const REVERT_TEXT_EXTRACT_REQUEST_FAILED = "REVERT_TEXT_EXTRACT_REQUEST_FAILED"
export const REVERT_TEXT_EXTRACT_REQUEST_CLEAR = "REVERT_TEXT_EXTRACT_REQUEST_CLEAR"
export const REVERT_TEXT_EXTRACT_REQUEST_CLEAR_ALL = "REVERT_TEXT_EXTRACT_REQUEST_CLEAR_ALL"

export const GET_CASE_DETAILS_REQUEST = "GET_CASE_DETAILS_REQUEST"
export const GET_CASE_DETAILS_REQUEST_SUCCESS = "GET_CASE_DETAILS_REQUEST_SUCCESS"
export const GET_CASE_DETAILS_REQUEST_FAILED = "GET_CASE_DETAILS_REQUEST_FAILED"
export const GET_CASE_DETAILS_REQUEST_FAILED_CLEAR = "GET_CASE_DETAILS_REQUEST_FAILED_CLEAR"

export const GET_EXTRACT_JOB_DETAILS_REQUEST = "GET_EXTRACT_JOB_DETAILS_REQUEST"
export const GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS = "GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS"
export const GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED = "GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED"
export const GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR = "GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR"

export const GET_UPLOAD_JOB_DETAILS_REQUEST = "GET_UPLOAD_JOB_DETAILS_REQUEST"
export const GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS = "GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS"
export const GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED = "GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED"
export const GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR = "GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR"

export const GET_KB_MAKING_DETAILS_REQUEST = "GET_KB_MAKING_DETAILS_REQUEST"
export const GET_KB_MAKING_DETAILS_REQUEST_SUCCESS = "GET_KB_MAKING_DETAILS_REQUEST_SUCCESS"
export const GET_KB_MAKING_DETAILS_REQUEST_FAILED = "GET_KB_MAKING_DETAILS_REQUEST_FAILED"
export const GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR = "GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR"

export const GET_PII_DETAILS_REQUEST = "GET_PII_DETAILS_REQUEST"
export const GET_PII_DETAILS_REQUEST_SUCCESS = "GET_PII_DETAILS_REQUEST_SUCCESS"
export const GET_PII_DETAILS_REQUEST_FAILED = "GET_PII_DETAILS_REQUEST_FAILED"
export const GET_PII_DETAILS_REQUEST_FAILED_CLEAR = "GET_PII_DETAILS_REQUEST_FAILED_CLEAR"

export const GET_UPLOAD_FILE_SUMMARY_REQUEST = "GET_UPLOAD_FILE_SUMMARY_REQUEST"
export const GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS = "GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS"
export const GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED = "GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED"
export const GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR = "GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR"

export const DELETE_CASE_REQUEST = "DELETE_CASE_REQUEST"
export const DELETE_CASE_REQUEST_SUCCESS = "DELETE_CASE_REQUEST_SUCCESS"
export const DELETE_CASE_REQUEST_FAILED = "DELETE_CASE_REQUEST_FAILED"
export const DELETE_CASE_REQUEST_CLEAR = "DELETE_CASE_REQUEST_CLEAR"

export const CHANGE_CASE_MODE_REQUEST = "CHANGE_CASE_MODE_REQUEST"
export const CHANGE_CASE_MODE_REQUEST_SUCCESS = "CHANGE_CASE_MODE_REQUEST_SUCCESS"
export const CHANGE_CASE_MODE_REQUEST_FAILED = "CHANGE_CASE_MODE_REQUEST_FAILED"
export const CHANGE_CASE_MODE_REQUEST_CLEAR = "CHANGE_CASE_MODE_REQUEST_CLEAR"

//Document Modal
export const GET_DOCUMENT_ROW_CLICK_REQUEST = "GET_DOCUMENT_ROW_CLICK_REQUEST"
export const GET_DOCUMENT_PAGE_REQUEST = "GET_DOCUMENT_PAGE_REQUEST"

export const GET_DOCUMENT_REQUEST_SUCCESS = "GET_DOCUMENT_REQUEST_SUCCESS"
export const GET_DOCUMENT_REQUEST_FAILED = "GET_DOCUMENT_REQUEST_FAILED"
export const GET_DOCUMENT_REQUEST_FAILED_CLEAR = "GET_DOCUMENT_REQUEST_FAILED_CLEAR"

export const UPDATE_DOCUMENT_MODAL_COMMENTS = "UPDATE_DOCUMENT_MODAL_COMMENTS"
export const UPDATE_DOCUMENT_MODAL_REVIEW = "UPDATE_DOCUMENT_MODAL_REVIEW"

export const SET_NOTIFICATION = "SET_NOTIFICATION"
export const RESET_NOTIFICATION = "RESET_NOTIFICATION"
export const UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT = "UPDATE_PAGE_NUMBER_FOR_CURRENT_DOCUMENT"

//Search Files List Doc view
export const GET_FILE_LIST_REQUEST = "GET_FILE_LIST_REQUEST"
export const GET_FILE_LIST_REQUEST_SUCCESS = "GET_FILE_LIST_REQUEST_SUCCESS"
export const GET_FILE_LIST_REQUEST_FAILED = "GET_DOCUMENT_REQUEST_FAILED"
export const GET_FILE_LIST_REQUEST_FAILED_CLEAR = "GET_DOCUMENT_REQUEST_FAILED_CLEAR"

export const UPDATE_FILE_LIST_TAG = "UPDATE_FILE_LIST_TAG"

export const UPDATE_META_DATA_COMMENT_COUNT = "UPDATE_META_DATA_COMMENT_COUNT"

export const MODE = "MODE"

/****************Ragnar Lodbrok****************/
//users
export const GET_USERS_LIST_REQUEST = "GET_USERS_LIST_REQUEST"
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS"
export const GET_USERS_LIST_FAILED = "GET_USERS_LIST_FAILED"
export const GET_USERS_LIST_RESET = "GET_USERS_LIST_RESET"

//from Emails list
export const GET_FROM_EMAILS_LIST_REQUEST = "GET_FROM_EMAILS_LIST_REQUEST"
export const GET_FROM_EMAILS_LIST_SUCCESS = "GET_FROM_EMAILS_LIST_SUCCESS"
export const GET_FROM_EMAILS_LIST_FAILED = "GET_FROM_EMAILS_LIST_FAILED"
export const GET_FROM_EMAILS_LIST_RESET = "GET_FROM_EMAILS_LIST_RESET"

//Sources list
export const GET_SOURCES_LIST_REQUEST = "GET_SOURCES_LIST_REQUEST"
export const GET_SOURCES_LIST_SUCCESS = "GET_SOURCES_LIST_SUCCESS"
export const GET_SOURCES_LIST_FAILED = "GET_SOURCES_LIST_FAILED"
export const GET_SOURCES_LIST_RESET = "GET_SOURCES_LIST_RESET"

//to Emails list
export const GET_TO_EMAILS_LIST_REQUEST = "GET_TO_EMAILS_LIST_REQUEST"
export const GET_TO_EMAILS_LIST_SUCCESS = "GET_TO_EMAILS_LIST_SUCCESS"
export const GET_TO_EMAILS_LIST_FAILED = "GET_TO_EMAILS_LIST_FAILED"
export const GET_TO_EMAILS_LIST_RESET = "GET_TO_EMAILS_LIST_RESET"

//Retain Filters list from job
export const GET_RETAIN_FILTERS_LIST_REQUEST = "GET_RETAIN_FILTERS_LIST_REQUEST"
export const GET_RETAIN_FILTERS_LIST_SUCCESS = "GET_RETAIN_FILTERS_LIST_SUCCESS"
export const GET_RETAIN_FILTERS_LIST_FAILED = "GET_RETAIN_FILTERS_LIST_FAILED"
export const GET_RETAIN_FILTERS_LIST_RESET = "GET_RETAIN_FILTERS_LIST_RESET"

//Review Overview Details
export const GET_REVIEW_OVERVIEW_DETAILS_REQUEST = "GET_REVIEW_OVERVIEW_DETAILS_REQUEST"
export const GET_REVIEW_OVERVIEW_DETAILS_SUCCESS = "GET_REVIEW_OVERVIEW_DETAILS_SUCCESS"
export const GET_REVIEW_OVERVIEW_DETAILS_FAILED = "GET_REVIEW_OVERVIEW_DETAILS_FAILED"
export const GET_REVIEW_OVERVIEW_DETAILS_RESET = "GET_REVIEW_OVERVIEW_DETAILS_RESET"

//User Review Overview Details
export const GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST = "GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST"
export const GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS = "GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS"
export const GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED = "GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED"
export const GET_USER_REVIEW_OVERVIEW_DETAILS_RESET = "GET_USER_REVIEW_OVERVIEW_DETAILS_RESET"

//Apply OR Update file tags
export const UPDATE_FILE_TAG = "UPDATE_FILE_TAG"
export const UPDATE_FILE_TAG_SUCCESS = "UPDATE_FILE_TAG_SUCCESS"
export const UPDATE_FILE_TAG_FAILED = "UPDATE_FILE_TAG_FAILED"
export const UPDATE_FILE_TAG_RESET = "UPDATE_FILE_TAG_RESET"
//Download files

export const DOWNLOAD_SINGLE_FILE = "DOWNLOAD_SINGLE_FILE"
export const DOWNLOAD_MULTIPLE_FILE = "DOWNLOAD_MULTIPLE_FILE"

export const DELETE_SINGLE_FILE = "DELETE_SINGLE_FILE"
export const DELETE_MULTIPLE_FILE = "DELETE_MULTIPLE_FILE"
export const FILE_IS_DELETED = "FILE_IS_DELETED"
export const RELOAD_LIST = "RELOAD_LIST"

export const GET_FILE_REQUEST = "GET_FILE_REQUEST"
export const GET_FILE_REQUEST_SUCCESS = "GET_FILE_REQUEST_SUCCESS"
export const GET_FILE_REQUEST_FAILED = "GET_FILE_REQUEST_FAILED"
export const GET_FILE_REQUEST_FAILED_CLEAR = "GET_FILE_REQUEST_FAILED_CLEAR"

export const GET_FILE_PAGE_REQUEST = "GET_FILE_PAGE_REQUEST"
export const GET_FILE_PAGE_REQUEST_SUCCESS = "GET_FILE_PAGE_REQUEST_SUCCESS"
export const GET_FILE_PAGE_REQUEST_FAILED = "GET_FILE_PAGE_REQUEST_FAILED"
export const GET_FILE_ROW_CLICK_REQUEST = "GET_FILE_ROW_CLICK_REQUEST"
export const GET_FILE_PAGE_REQUEST_FAILED_CLEAR = "GET_FILE_PAGE_REQUEST_FAILED_CLEAR"
//Filter Changes
export const SET_FILTER_DATA = "SET_FILTER_DATA"
export const SET_FILTER_JOBID = "SET_FILTER_JOBID"

export const RESET_PAGE_VIEWER = "RESET_PAGE_VIEWER"

export const GET_PAGE_NUMBER_BASED_ON_DOC_ID = "GET_PAGE_NUMBER_BASED_ON_DOC_ID"
export const GET_PAGE_NUMBER_BASED_ON_DOC_ID_SUCCESS = "GET_PAGE_NUMBER_BASED_ON_DOC_ID_SUCCESS"
export const GET_PAGE_NUMBER_BASED_ON_DOC_ID_FAILED = "GET_PAGE_NUMBER_BASED_ON_DOC_ID_FAILED"
export const GET_PAGE_NUMBER_BASED_ON_DOC_ID_RESET = "GET_PAGE_NUMBER_BASED_ON_DOC_ID_RESET"

export const GET_COMMENTS = "GET_COMMENTS"
export const GET_INFO = "GET_INFO"
export const GET_INFO_SUCCESS = "GET_INFO_SUCCESS"
export const GET_INFO_FAILED = "GET_INFO_FAILED"

export const GET_VIEWER_ALL_DOCUMENTS_REQUEST = "GET_VIEWER_ALL_DOCUMENTS_REQUEST"
export const GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS = "GET_VIEWER_ALL_DOCUMENTS_REQUEST_SUCCESS"
export const GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED = "GET_VIEWER_ALL_DOCUMENTS_REQUEST_FAILED"
export const GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET = "GET_VIEWER_ALL_DOCUMENTS_REQUEST_RESET"
export const UPDATE_VIEWER_PAGE_NUMBER = "UPDATE_VIEWER_PAGE_NUMBER"

//dashboard analytics
export const GET_ANALYTICS_REQUEST = "GET_ANALYTICS_REQUEST"
export const GET_ANALYTICS_SUCCESS = "GET_ANALYTICS_SUCCESS"
export const GET_ANALYTICS_FAILED = "GET_ANALYTICS_FAILED"
export const GET_ANALYTICS_RESET = "GET_ANALYTICS_RESET"

// user list
export const GET_USER_MANAGEMENT_LIST = "GET_USER_MANAGEMENT_LIST"
export const GET_USER_MANAGEMENT_LIST_SUCCESS = "GET_USER_MANAGEMENT_LIST_SUCCESS"
export const GET_USER_MANAGEMENT_LIST_FAILED = "GET_USER_MANAGEMENT_LIST_FAILED"
export const GET_USER_MANAGEMENT_LIST_RESET = "GET_USER_MANAGEMENT_LIST_RESET"

//review
export const SET_REVIEW = "SET_REVIEW"
export const RESET_REVIEW = "RESET_REVIEW"
export const SET_REVIEW_JOBID = "SET_REVIEW_JOBID"
export const SET_REVIEW_ASSIGNEE = "SET_REVIEW_ASSIGNEE"
export const SET_REVIEW_CURRENT_ASSIGNEE = "SET_REVIEW_CURRENT_ASSIGNEE"
export const SET_REVIEW_ASSIGNEE_MAP = "SET_REVIEW_ASSIGNEE_MAP"
export const RESET_REVIEW_FORM = "RESET_REVIEW_FORM"

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST"
export const CREATE_REVIEW_REQUEST_SUCCESS = "CREATE_REVIEW_REQUEST_SUCCESS"
export const CREATE_REVIEW_REQUEST_FAILED = "CREATE_REVIEW_REQUEST_FAILED"
export const CREATE_REVIEW_REQUEST_RESET = "CREATE_REVIEW_REQUEST_RESET"

export const GET_REVIEW_LIST_REQUEST = "GET_REVIEW_LIST_REQUEST"
export const GET_REVIEW_LIST_REQUEST_SUCCESS = "GET_REVIEW_LIST_REQUEST_SUCCESS"
export const GET_REVIEW_LIST_REQUEST_FAILED = "GET_REVIEW_LIST_REQUEST_FAILED"
export const GET_REVIEW_LIST_REQUEST_RESET = "GET_REVIEW_LIST_REQUEST_RESET"

export const GET_ALL_REVIEWS_LIST_REQUEST = "GET_ALL_REVIEWS_LIST_REQUEST"
export const GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS = "GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS"
export const GET_ALL_REVIEWS_LIST_REQUEST_FAILED = "GET_ALL_REVIEWS_LIST_REQUEST_FAILED"
export const GET_ALL_REVIEWS_LIST_REQUEST_RESET = "GET_ALL_REVIEWS_LIST_REQUEST_RESET"

export const GET_REVIEW_REQUEST = "GET_REVIEW_REQUEST"
export const GET_REVIEW_REQUEST_SUCCESS = "GET_REVIEW_REQUEST_SUCCESS"
export const GET_REVIEW_REQUEST_FAILED = "GET_REVIEW_REQUEST_FAILED"
export const GET_REVIEW_REQUEST_RESET = "GET_REVIEW_REQUEST_RESET"

export const SET_REVIEW_RESTRICT_IDS = "SET_REVIEW_RESTRICT_IDS"
export const SET_REVIEW_FORM_OPEN = "SET_REVIEW_FORM_OPEN"
export const UPDATE_REVIEW_METADATA = "UPDATE_REVIEW_METADATA"
export const IS_UPDATE_TRIGGER = "IS_UPDATE_TRIGGER"
export const IS_CASE_ADMIN = "IS_CASE_ADMIN"

export const SET_DASHBOARD_REVIEW = "SET_DASHBOARD_REVIEW"

//audit history list
export const GET_AUDIT_DETAILS_REQUEST = "GET_AUDIT_DETAILS_REQUEST"
export const GET_AUDIT_DETAILS_SUCCESS = "GET_AUDIT_DETAILS_SUCCESS"
export const GET_AUDIT_DETAILS_FAILED = "GET_AUDIT_DETAILS_FAILED"
export const GET_AUDIT_DETAILS_RESET = "GET_AUDIT_DETAILS_RESET"

// create user
export const POST_CREATE_USER_REQUEST = "POST_CREATE_USER_REQUEST"
export const POST_CREATE_USER_REQUEST_SUCCESS = "POST_CREATE_USER_REQUEST_SUCCESS"
export const POST_CREATE_USER_REQUEST_FAILED = "POST_CREATE_USER_REQUEST_FAILED"
export const POST_CREATE_USER_REQUEST_RESET = "POST_CREATE_USER_REQUEST_RESET"

// update user
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST"
export const UPDATE_USER_REQUEST_SUCCESS = "UPDATE_USER_REQUEST_SUCCESS"
export const UPDATE_USER_REQUEST_FAILED = "UPDATE_USER_REQUEST_FAILED"
export const UPDATE_USER_REQUEST_RESET = "UPDATE_USER_REQUEST_RESET"

// delete user
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST"
export const DELETE_USER_REQUEST_SUCCESS = "DELETE_USER_REQUEST_SUCCESS"
export const DELETE_USER_REQUEST_FAILED = "DELETE_USER_REQUEST_FAILED"
export const DELETE_USER_REQUEST_RESET = "DELETE_USER_REQUEST_RESET"

export const GET_AUDIT_HISTORY = "GET_AUDIT_HISTORY"
export const GET_AUDIT_HISTORY_SUCCESS = "GET_AUDIT_HISTORY_SUCCESS"
export const GET_AUDIT_HISTORY_FAILED = "GET_AUDIT_HISTORY_FAILED"

//  Email availability check
export const EMAIL_AVAILABILITY_CHECK = "EMAIL_AVAILABILITY_CHECK"
export const EMAIL_AVAILABILITY_CHECK_SUCCESS = "EMAIL_AVAILABILITY_CHECK_SUCCESS"
export const EMAIL_AVAILABILITY_CHECK_FAILED = "EMAIL_AVAILABILITY_CHECK_FAILED"
export const EMAIL_AVAILABILITY_CHECK_RESET = "EMAIL_AVAILABILITY_CHECK_RESET"

//updateReviewStatus
export const UPDATE_REVIEW_STATUS = "UPDATE_REVIEW_STATUS"
export const UPDATE_REVIEW_STATUS_SUCCESS = "UPDATE_REVIEW_STATUS_SUCCESS"
export const UPDATE_REVIEW_STATUS_FAILED = "UPDATE_REVIEW_STATUS_FAILED"
export const UPDATE_REVIEW_STATUS_RESET = "UPDATE_REVIEW_STATUS_RESET"
export const GET_REVIEW_BASED_ON_ID = "GET_REVIEW_BASED_ON_ID"
export const GET_REVIEW_BASED_ON_ID_SUCCESS = "GET_REVIEW_BASED_ON_ID_SUCCESS"
export const GET_REVIEW_BASED_ON_ID_FAILED = "GET_REVIEW_BASED_ON_ID_FAILED"
export const GET_REVIEW_BASED_ON_ID_RESET = "GET_REVIEW_BASED_ON_ID_RESET"

//multiTag

export const TAG_BUTTON_CLICKED = "TAG_BUTTON_CLICKED"
export const TAG_BUTTON_CLICKED_RESET = "TAG_BUTTON_CLICKED_RESET"

export const REMOVE_ANNOTATION = "REMOVE_ANNOTATION"
export const GET_ANNOTATION = "GET_ANNOTATION"
export const GET_ANNOTATION_SUCCESS = "GET_ANNOTATION_SUCCESS"
export const GET_ANNOTATION_FAILED = "GET_ANNOTATION_FAILED"
export const ADD_ANNOTATION = "ADD_ANNOTATION"
export const ADD_ANNOTATION_SUCCESS = "ADD_ANNOTATION_SUCCESS"
export const ADD_ANNOTATION_FAILED = "ADD_ANNOTATION_FAILED"
export const DELETE_ANNOTATION = "DELETE_ANNOTATION"
export const DELETE_ANNOTATION_SUCCESS = "DELETE_ANNOTATION_SUCCESS"
export const DELETE_ANNOTATION_FAILED = "DELETE_ANNOTATION_FAILED"

export const GET_NOTIFICATION = "GET_NOTIFICATION"
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS"
export const GET_NOTIFICATION_FAILED = "GET_NOTIFICATION_FAILED"
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION"
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS"
export const UPDATE_NOTIFICATION_FAILED = "UPDATE_NOTIFICATION_FAILED"
export const GET_CASE_ACCESS_LIST = "GET_CASE_ACCESS_LIST"

export const GET_CASE_ACCESS_LIST_SUCCESS = "GET_CASE_ACCESS_LIST_SUCCESS"
export const GET_CASE_ACCESS_LIST_FAIL = "GET_CASE_ACCESS_LIST_FAIL"
export const GET_CASE_ACCESS_LIST_RESET = "GET_CASE_ACCESS_LIST_RESET"

export const GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT = "GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT"
export const GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS = "GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_SUCCESS"
export const GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED = "GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_FAILED"
export const GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET = "GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT_RESET"

export const SHOW_DUPLICATE = "SHOW_DUPLICATE"
export const SHOW_DUPLICATE_RESET = "SHOW_DUPLICATE_RESET"

export const UPDATE_SKIP_COUNT = "UPDATE_SKIP_COUNT"

export const SET_P_SEARCH_API_CALL = "SET_P_SEARCH_API_CALL"
export const RESET_P_SEARCH_API_CALL = "RESET_P_SEARCH_API_CALL"

export const GET_SAVED_DATE_RANGE = "GET_SAVED_DATE_RANGE"
export const GET_SAVED_DATE_RANGE_SUCCESS = "GET_SAVED_DATE_RANGE_SUCCESS"
export const GET_SAVED_DATE_RANGE_FAIL = "GET_SAVED_DATE_RANGE_FAIL"
export const GET_SAVED_DATE_RANGE_CLEAR = "GET_SAVED_DATE_RANGE_CLEAR"

export const GET_SAVED_DATE_RANGE_NAME_CHECK = "GET_SAVED_DATE_RANGE_NAME_CHECK"
export const GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS = "GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS"
export const GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL = "GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL"

export const POST_SAVED_DATE_RANGE = "POST_SAVED_DATE_RANGE"
export const POST_SAVED_DATE_RANGE_SUCCESS = "POST_SAVED_DATE_RANGE_SUCCESS"
export const POST_SAVED_DATE_RANGE_FAIL = "POST_SAVED_DATE_RANGE_FAIL"
export const POST_SAVED_DATE_RANGE_CLEAR = "POST_SAVED_DATE_RANGE_CLEAR"

export const DELETE_SAVED_DATE_RANGE = "DELETE_SAVED_DATE_RANGE"
export const DELETE_SAVED_DATE_RANGE_SUCCESS = "DELETE_SAVED_DATE_RANGE_SUCCESS"
export const DELETE_SAVED_DATE_RANGE_FAIL = "DELETE_SAVED_DATE_RANGE_FAIL"

//Billing

export const GET_BILLING_CHARACTER_COUNT = "GET_BILLING_CHARACTER_COUNT"
export const GET_BILLING_CHARACTER_COUNT_SUCCESS = "GET_BILLING_CHARACTER_COUNT_SUCCESS"
export const GET_BILLING_CHARACTER_COUNT_FAIL = "GET_BILLING_CHARACTER_COUNT_FAIL"
export const GET_BILLING_CHARACTER_COUNT_CLEAR = "GET_BILLING_CHARACTER_COUNT_CLEAR"

export const GET_BILLING_USER_LOGIN_DETAILS = "GET_BILLING_USER_LOGIN_DETAILS"
export const GET_BILLING_USER_LOGIN_DETAILS_SUCCESS = "GET_BILLING_USER_LOGIN_DETAILS_SUCCESS"
export const GET_BILLING_USER_LOGIN_DETAILS_FAIL = "GET_BILLING_USER_LOGIN_DETAILS_FAIL"
export const GET_BILLING_USER_LOGIN_DETAILS_CLEAR = "GET_BILLING_USER_LOGIN_DETAILS_CLEAR"
export const SET_PAGE_NUMBER_CHAR_COUNT = "SET_PAGE_NUMBER_CHAR_COUNT"
export const SET_PAGE_NUMBER_USER_LOGIN_DETAILS = "SET_PAGE_NUMBER_USER_LOGIN_DETAILS"

//events
export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST"
export const GET_EVENTS_REQUEST_SUCCESS = "GET_EVENTS_REQUEST_SUCCESS"
export const GET_EVENTS_REQUEST_FAILED = "GET_EVENTS_REQUEST_FAILED"
export const GET_EVENTS_REQUEST_CLEAR = "GET_EVENTS_REQUEST_CLEAR"

export const SAVE_EVENT_REQUEST = "SAVE_EVENT_REQUEST"
export const SAVE_EVENT_REQUEST_SUCCESS = "SAVE_EVENT_REQUEST_SUCCESS"
export const SAVE_EVENT_REQUEST_FAILED = "SAVE_EVENT_REQUEST_FAILED"
export const SAVE_EVENT_REQUEST_CLEAR = "SAVE_EVENT_REQUEST_CLEAR"

export const DELETE_EVENT_REQUEST = "DELETE_EVENT_REQUEST"
export const DELETE_EVENT_REQUEST_SUCCESS = "DELETE_EVENT_REQUEST_SUCCESS"
export const DELETE_EVENT_REQUEST_FAILED = "DELETE_EVENT_REQUEST_FAILED"
export const DELETE_EVENT_REQUEST_CLEAR = "DELETE_EVENT_REQUEST_CLEAR"

export const SET_SELECTED_EVENTS = "SET_SELECTED_EVENTS"
export const SET_SELECTED_EVENT = "SET_SELECTED_EVENT"
export const OPEN_EVENT_FORM = "OPEN_EVENT_FORM"

//tagged date
export const TAGGED_DATE_EDIT_BUTTON_CLICKED = "TAGGED_DATE_EDIT_BUTTON_CLICKED"
export const TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET = "TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET"

export const UPDATE_TAGGED_DATE_REQUEST = "UPDATE_TAGGED_DATE_REQUEST"
export const UPDATE_TAGGED_DATE_REQUEST_SUCCESS = "UPDATE_TAGGED_DATE_REQUEST_SUCCESS"
export const UPDATE_TAGGED_DATE_REQUEST_FAILED = "UPDATE_TAGGED_DATE_REQUEST_FAILED"
export const UPDATE_TAGGED_DATE_REQUEST_RESET = "UPDATE_TAGGED_DATE_REQUEST_RESET"

//Dynamic email
export const GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST = "GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST"
export const GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS = "GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS"
export const GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED = "GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED"
export const GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_RESET = "GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_RESET"

export const GET_DYNAMIC_TO_EMAILS_LIST_REQUEST = "GET_DYNAMIC_TO_EMAILS_LIST_REQUEST"
export const GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS = "GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS"
export const GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED = "GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED"
export const GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_RESET = "GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_RESET"

//Bifrost job details
export const GET_BIFROST_JOB_DETAILS_REQUEST = "GET_BIFROST_JOB_DETAILS_REQUEST"
export const GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS = "GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS"
export const GET_BIFROST_JOB_DETAILS_REQUEST_FAILED = "GET_BIFROST_JOB_DETAILS_REQUEST_FAILED"
export const GET_BIFROST_JOB_DETAILS_REQUEST_RESET = "GET_BIFROST_JOB_DETAILS_REQUEST_RESET"

export const POST_BIFROST_JOB_REQUEST = "POST_BIFROST_JOB_REQUEST"
export const POST_BIFROST_JOB_REQUEST_SUCCESS = "POST_BIFROST_JOB_REQUEST_SUCCESS"
export const POST_BIFROST_JOB_REQUEST_FAILED = "POST_BIFROST_JOB_REQUEST_FAILED"
export const POST_BIFROST_JOB_REQUEST_RESET = "POST_BIFROST_JOB_REQUEST_RESET"

export const LOG_AUDIT = "LOG_AUDIT"

export const ZOOM_IN_IMAGE = "ZOOM_IN_IMAGE"
export const ZOOM_OUT_IMAGE = "ZOOM_OUT_IMAGE"
export const ROTATE_LEFT_IMAGE = "ROTATE_LEFT_IMAGE"
export const ROTATE_RIGHT_IMAGE = "ROTATE_RIGHT_IMAGE"

//Continuous upload
export const OPEN_UPLOAD = "OPEN_UPLOAD"

export const GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST = "GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST"
export const GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS = "GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS"
export const GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED = "GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED"
export const GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET = "GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET"

export const POST_UPLOAD_FILE_REQUEST = "POST_UPLOAD_FILE_REQUEST"
export const POST_UPLOAD_FILE_SUCCESS = "POST_UPLOAD_FILE_SUCCESS"
export const POST_UPLOAD_FILE_FAILED = "POST_UPLOAD_FILE_FAILED"
export const POST_UPLOAD_FILE_RESET = "POST_UPLOAD_FILE_RESET"

export const GET_UPLOAD_FILE_STATUS_REQUEST = "GET_UPLOAD_FILE_STATUS_REQUEST"
export const GET_UPLOAD_FILE_STATUS_SUCCESS = "GET_UPLOAD_FILE_STATUS_SUCCESS"
export const GET_UPLOAD_FILE_STATUS_FAILED = "GET_UPLOAD_FILE_STATUS_FAILED"
export const GET_UPLOAD_FILE_STATUS_RESET = "GET_UPLOAD_FILE_STATUS_RESET"

//update password
export const GET_CHAT = "GET_CHAT"
export const GET_CHAT_SUCCESS = "GET_CHAT_SUCCESS"
export const GET_CHAT_FAILED = "GET_CHAT_FAILED"
export const GET_CHAT_RESET = "GET_CHAT_RESET"

export const POST_CHAT = "POST_CHAT"
export const POST_CHAT_SUCCESS = "POST_CHAT_SUCCESS"
export const POST_CHAT_FAILED = "POST_CHAT_FAILED"
export const POST_CHAT_RESET = "POST_CHAT_RESET"

export const UPDATE_CURRENT_SESSION = "UPDATE_CURRENT_SESSION"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL"
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET"

export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_FAIL = "FORGET_PASSWORD_FAIL"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_RESET = "FORGET_PASSWORD_RESET"

export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL"
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_RESET = "RESET_PASSWORD_RESET"

export const REDIRECT_TO_HOME = "REDIRECT_TO_HOME"
